import React, { useContext } from 'react';
import { FormContext } from '../../context/EquipmentFormContext';
import { LuMapPin } from 'react-icons/lu';

// ============================================================
// DROPDOWN OPTIONS
// ============================================================

const locationOptions = [
  'Main Kitchen',
  'Prep Kitchen',
  'Cold Storage',
  'Dry Storage',
  'Bakery',
  'Restaurant Floor',
  'Bar Area',
  'Warehouse',
  'Maintenance Room',
  'Loading Area',
];

const ownershipOptions = [
  'Owned',
  'Leased',
  'Rented',
  'Company Property',
  'Third Party',
];

const assignedToOptions = [
  'John Smith',
  'Sarah Williams',
  'Michael Brown',
  'David Wilson',
  'Emily Johnson',
  'Kitchen Manager',
  'Maintenance Manager',
];

export default function Step2() {
  const { formData, updateField } = useContext(FormContext);

  return (
    <div className="bg-white rounded-xl border border-slate-100 p-6 shadow-sm">

      {/* ========================================================
          HEADER
      ======================================================== */}

      <div className="flex items-start space-x-4 mb-6">

        <div className="p-2 bg-blue-600 rounded-lg text-white">
          <LuMapPin className="w-5 h-5 stroke-[2.5]" />
        </div>

        <div>

          <div className="flex items-center space-x-2">

            <span className="text-xs font-bold bg-blue-50 text-blue-700 px-1.5 py-0.5 rounded">
              2
            </span>

            <h2 className="text-base font-bold text-indigo-950">
              Location & Ownership
            </h2>

          </div>

          <p className="text-xs text-slate-500 mt-0.5">
            Where the equipment is located and who is responsible for it.
          </p>

        </div>

      </div>

      {/* ========================================================
          FORM
      ======================================================== */}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

        {/* ======================================================
            LOCATION
        ====================================================== */}

        <div>

          <label className="block text-xs font-semibold text-slate-700 mb-1">
            Location <span className="text-red-500">*</span>
          </label>

          <select
            value={formData.location}
            onChange={(e) =>
              updateField('location', e.target.value)
            }
            className="w-full text-sm border border-slate-200 rounded-lg px-3 py-2 text-slate-800 bg-white focus:outline-none focus:ring-2 focus:ring-blue-100"
          >

            <option value="">
              Select location
            </option>

            {locationOptions.map((location) => (
              <option
                key={location}
                value={location}
              >
                {location}
              </option>
            ))}

          </select>

        </div>

        {/* ======================================================
            SPECIFIC AREA
        ====================================================== */}

        <div>

          <label className="block text-xs font-semibold text-slate-700 mb-1">
            Specific Area
          </label>

          <input
            type="text"
            value={formData.specificArea}
            onChange={(e) =>
              updateField(
                'specificArea',
                e.target.value
              )
            }
            placeholder="e.g. Main Kitchen, Prep Area"
            className="w-full text-sm border border-slate-200 rounded-lg px-3 py-2 text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-100"
          />

        </div>

        {/* ======================================================
            OWNERSHIP
        ====================================================== */}

        <div>

          <label className="block text-xs font-semibold text-slate-700 mb-1">
            Ownership
          </label>

          <select
            value={formData.ownership}
            onChange={(e) =>
              updateField(
                'ownership',
                e.target.value
              )
            }
            className="w-full text-sm border border-slate-200 rounded-lg px-3 py-2 text-slate-800 bg-white focus:outline-none focus:ring-2 focus:ring-blue-100"
          >

            <option value="">
              Select ownership
            </option>

            {ownershipOptions.map((ownership) => (
              <option
                key={ownership}
                value={ownership}
              >
                {ownership}
              </option>
            ))}

          </select>

        </div>

        {/* ======================================================
            ASSIGNED TO
        ====================================================== */}

        <div>

          <label className="block text-xs font-semibold text-slate-700 mb-1">
            Assigned To (Responsible Person)
          </label>

          <select
            value={formData.assignedTo}
            onChange={(e) =>
              updateField(
                'assignedTo',
                e.target.value
              )
            }
            className="w-full text-sm border border-slate-200 rounded-lg px-3 py-2 text-slate-800 bg-white focus:outline-none focus:ring-2 focus:ring-blue-100"
          >

            <option value="">
              Select staff member
            </option>

            {assignedToOptions.map((staff) => (
              <option
                key={staff}
                value={staff}
              >
                {staff}
              </option>
            ))}

          </select>

        </div>

        {/* ======================================================
            SUPPLIER
        ====================================================== */}

        <div>

          <label className="block text-xs font-semibold text-slate-700 mb-1">
            Supplier{' '}
            <span className="text-slate-400 font-normal">
              (optional)
            </span>
          </label>

          <input
            type="text"
            value={formData.supplier}
            onChange={(e) =>
              updateField(
                'supplier',
                e.target.value
              )
            }
            placeholder="e.g. ABC Catering Ltd"
            className="w-full text-sm border border-slate-200 rounded-lg px-3 py-2 text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-100"
          />

        </div>

      </div>

    </div>
  );
}